"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
var revert_error_1 = require("../../revert_error");
// tslint:disable:max-classes-per-file
var ValueErrorCodes;
(function (ValueErrorCodes) {
    ValueErrorCodes[ValueErrorCodes["TooSmall"] = 0] = "TooSmall";
    ValueErrorCodes[ValueErrorCodes["TooLarge"] = 1] = "TooLarge";
})(ValueErrorCodes = exports.ValueErrorCodes || (exports.ValueErrorCodes = {}));
var BinOpErrorCodes;
(function (BinOpErrorCodes) {
    BinOpErrorCodes[BinOpErrorCodes["AdditionOverflow"] = 0] = "AdditionOverflow";
    BinOpErrorCodes[BinOpErrorCodes["MultiplicationOverflow"] = 1] = "MultiplicationOverflow";
    BinOpErrorCodes[BinOpErrorCodes["DivisionByZero"] = 2] = "DivisionByZero";
    BinOpErrorCodes[BinOpErrorCodes["DivisionOverflow"] = 3] = "DivisionOverflow";
})(BinOpErrorCodes = exports.BinOpErrorCodes || (exports.BinOpErrorCodes = {}));
var SignedValueError = /** @class */ (function (_super) {
    __extends(SignedValueError, _super);
    function SignedValueError(error, n) {
        return _super.call(this, 'SignedValueError', 'SignedValueError(uint8 error, int256 n)', {
            error: error,
            n: n,
        }) || this;
    }
    return SignedValueError;
}(revert_error_1.RevertError));
exports.SignedValueError = SignedValueError;
var UnsignedValueError = /** @class */ (function (_super) {
    __extends(UnsignedValueError, _super);
    function UnsignedValueError(error, n) {
        return _super.call(this, 'UnsignedValueError', 'UnsignedValueError(uint8 error, uint256 n)', {
            error: error,
            n: n,
        }) || this;
    }
    return UnsignedValueError;
}(revert_error_1.RevertError));
exports.UnsignedValueError = UnsignedValueError;
var BinOpError = /** @class */ (function (_super) {
    __extends(BinOpError, _super);
    function BinOpError(error, a, b) {
        return _super.call(this, 'BinOpError', 'BinOpError(uint8 error, int256 a, int256 b)', {
            error: error,
            a: a,
            b: b,
        }) || this;
    }
    return BinOpError;
}(revert_error_1.RevertError));
exports.BinOpError = BinOpError;
var types = [SignedValueError, UnsignedValueError, BinOpError];
try {
    // Register the types we've defined.
    for (var types_1 = __values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()) {
        var type = types_1_1.value;
        revert_error_1.RevertError.registerType(type);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
    }
    finally { if (e_1) throw e_1.error; }
}
//# sourceMappingURL=fixed_math_revert_errors.js.map